import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api-service';

@Injectable({
  providedIn: 'root',
})
export class OrderProcessingService {
  private readonly apiService = inject(ApiService);

  confirm(id: string): Observable<unknown> {
    return this.apiService.post(`fraud-orders/${id}/accept`, {});
  }

  decline(id: string): Observable<unknown> {
    return this.apiService.post(`fraud-orders/${id}/reject`, {});
  }
}
